import React from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

const reviews = [
  {
    review:
      "Thank you so much for your outstanding support — I’d easily rate your help a solid 10 out of 10. Your expertise, patience, and quick response made a big difference in resolving the issue. It’s clear you know your stuff, and your guidance really gave me confidence moving forward.",
    role: "Technical Onboarding Specialist",
    company: "GoodPWR",
  },
  {
    review:
      "Enerflo Support was very friendly, patient, and helpful. I wanted confirmation that what the chatbot suggested was the best path to take, and they confirmed it for me. Both the AI chat and Enerflo Support were great!",
    role: "Director of Sales Relations",
    company: "Unicity Solar",
  },
  {
    review:
      "Be it troubleshooting solar proposals or avenging your dojo, I would trust Enerflo Support with the completion of either task.",
    role: "Funding Manager",
    company: "ZEO Energy",
  },
  {
    review: "Very helpful! Understood what I was asking and gave very quick answers. 10/10",
    role: "Customer Service Manager",
    company: "Gault Electric",
  },
];

const title = "AI + Human";

const AIPlusHuman = () => {
  return (
    <HeroSection title={title} className="bg-white">
      <HeroSection.Content className="space-y-10">
        <header className="text-center mb-12">
          <HeroSection.Tagline className="text-navy mb-8">{title}</HeroSection.Tagline>
          <Heading tag="h2" className="mb-6">
            <span className="text-navy">Flo + Real Humans.</span>{" "}
            <span className="text-primary">In under a minute.</span>
          </Heading>
          <p className="text-lg text-gray-600">
            Flo, Enerflo's AI assistant, is the first layer of support: solar-fluent, available instantly, and getting
            sharper every week. For anything that needs a human, our specialists step in without delay. You get fast
            answers from an AI that actually knows the OS, backed by a team that knows residential solar.
          </p>
        </header>

        <div>
          <HeroSection.Tagline className="text-navy mb-8 text-center">What Our Partners Are Saying</HeroSection.Tagline>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-8 text-navy sm:text-left">
            {reviews.map((item, index) => (
              <div key={index} className="bg-primary/20 rounded-xl p-4 flex flex-col justify-around md:p-6">
                <p className="italic">"{item.review}"</p>
                <p className="mt-4">
                  {item.role} | {item.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </HeroSection.Content>
    </HeroSection>
  );
};

export default AIPlusHuman;
